export const environment = {
  production: true,
  buildId: '3610869921622891',
  configFile: 'config.json',
};
